import React from "react";
import { v4 as uuidv4 } from 'uuid';
import { Button, Plus } from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "../CustomCampaignShowContainer";
import WorkflowNodeFilterGroupForm from "./WorkflowNodeFilterGroupForm";

export default () => {
  const {
    customCampaign,
    selectedNodeFormState,
    setSelectedNodeFormState,
  } = useCustomCampaignShowContext();

  const handleAddEventDataFilter = () => {
    const filterType = customCampaign?.trigger_filter_type;

    const newFilter = {
      type: filterType,
      tempId: uuidv4(),
    };

    if (Object.keys(selectedNodeFormState.filter_group || {}).length > 0) {
      setSelectedNodeFormState(prevState => ({
        ...prevState,
        filter_group: {
          ...prevState.filter_group,
          filters_attributes: [
            ...prevState.filter_group.filters_attributes,
            newFilter,
          ],
        }
      }));
    } else {
      setSelectedNodeFormState(prevState => ({
        ...prevState,
        filter_group: {
          ...prevState.filter_group,
          match_condition: "All",
          filters_attributes: [
            newFilter,
          ],
        }
      }));
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ fontSize: 16, fontWeight: 600, lineHeight: "24px", color: "var(--sl-text-primary)" }}>Conditions</div>
      {Object.keys(selectedNodeFormState?.filter_group || {}).length > 0 ? (
        <WorkflowNodeFilterGroupForm />
      ) : null}
      <div>
        <Button variant="link-color" size="sm" icon={Plus} onClick={handleAddEventDataFilter}>
          Add condition
        </Button>
      </div>
    </div>
  );
};
